// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__2-DeE","row":"ProcedureTreatmentSummary_row__zEOy9"};